/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from "react";
import Discuss from "parts/Discuss";
import Button from "elements/Button";
import BenefitsSection from "components/BenefitsSection";

export default function DisasterRecovery() {
  return (
    <>
      {/* FEATURES SECTION */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            Our Disaster Recovery Solutions
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            Ensure your systems, data, and business operations can survive any disaster and recover quickly.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Automated Backups
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Secure off-site and cloud backups that ensure your data is always protected.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Rapid Recovery
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Minimize downtime with fast system restoration and business-continuity plans.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Business Continuity Planning
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Customized continuity strategies to keep your business operational during crises.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION (Reusable) */}
      <BenefitsSection
        title="Why Disaster Recovery Matters"
        subtitle="Disruptions happen — having a tested recovery plan ensures your business survives them."
        benefits={[
          {
            id: "protect-data",
            title: "Protect Critical Business Data",
            text: "Ensure your important files, records, and systems are recoverable at any time.",
            delay: 0,
          },
          {
            id: "minimize-downtime",
            title: "Minimize Downtime",
            text: "Get your business back online quickly after hardware failure, cyberattacks, or natural disasters.",
            delay: 120,
          },
          {
            id: "compliance",
            title: "Meet Compliance Standards",
            text: "Industry-regulated backup and recovery requirements fully implemented.",
            delay: 240,
          },
        ]}
        gainsTitle="What You’ll Gain"
        gains={[
          { id: "recovery-time", text: "Reduced recovery time" },
          { id: "data-loss", text: "Lower risk of data loss" },
          { id: "resilience", text: "Improved resilience" },
          { id: "continuity", text: "Guaranteed business continuity" },
        ]}
      />

      {/* CTA SECTION */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Is your business ready for the unexpected?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              We’ll build a recovery plan that keeps you secure and operational.
            </p>
          </div>

          <Button
            href="/contact"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
